module.exports = __webpack_public_path__ + "static/img/ronyu.8e6e980.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/about/ronyu.png
// module id = cb3p
// module chunks = 1